<template>
    <div>
        <ToastMessage ref="toastMessage" :message="toast.message" :snackbarColor="toast.type"></ToastMessage>
        <notifications group="app"></notifications>
        <Inform ref="dialogInform"></Inform>
        <ProjectSelector ref="ProjectSelector"></ProjectSelector>
        <ProjectCreator ref="ProjectCreator"></ProjectCreator>
        <Confirm ref="Confirm"></Confirm>
    </div>
</template>
<script>
import ToastMessage from './ToastMessage'
import ProjectSelector from './ProjectSelector'
import ProjectCreator from './ProjectCreator'
import Confirm from './Confirm'
import Inform from './dialog/Inform'
import { EventBus, EventBusType } from '@/event-bus'

export default {
    name: 'AppServiceView',
    components: {
        ToastMessage,
        ProjectSelector,
        ProjectCreator,
        Confirm,
        Inform
    },
    data () {
        return {
            modal: {
                show: false,
                dialog: false,
                content: null,
                isText: false,
                onClose: null
            },
            toast: {
                message: '',
                type: ''
            },
            modalCreateProject: {
                show: false,
                errorMessages: '',
                projectName: '',
                apiId: '',
                nextAction: ''
            }
        }
    },
    mounted () {
        EventBus.$on(EventBusType.INFORM, ({ message, options }) => {
            this.$refs.dialogInform.open(message, options)
        })
        EventBus.$on(EventBusType.CLOSE_INFORM, () => {
            this.$refs.dialogInform.close()
        })
        EventBus.$on(EventBusType.TOAST, options => {
            this.$notify(options)
        })
        EventBus.$on(EventBusType.SELECT_PROJECT, options => {
            this.$refs.ProjectSelector.open().then(
                result => EventBus.$emit(EventBusType.SELECT_PROJECT_DONE, result)
            )
        })
        EventBus.$on(EventBusType.CREATE_PROJECT, options => {
            this.$refs.ProjectCreator.open().then(
                result => EventBus.$emit(EventBusType.CREATE_PROJECT_DONE, result)
            )
        })
        EventBus.$on(EventBusType.CONFIRM, message => {
            this.$refs.Confirm.open(message).then(
                result => EventBus.$emit(EventBusType.CONFIRM_DONE, result)
            )
        })
    },
    methods: {
        onModalClose () {
            if (this.modal.onClose) {
                this.modal.onClose()
            }
        }
    }
}
</script>
<style>
    .notifications {
        top: 15px !important;
        right: 15px !important;
    }

    .vue-notification {
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
        border-radius: 3px;
    }
</style>
